import styled from 'styled-components'
import bgImg from './assets/bg.png'

export const Container = styled.div`
  background-color: #FFF;
  display: flex;
  margin-bottom: 64px;
  overflow: hidden;
`

export const BackgroundContainer = styled.div`
  background-color: #00A988;
  background-image: url(${bgImg});
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 100px;
  position: relative;
  width: 100%;

  @media (min-width: 912px) {
    padding: 76px 72px 68px;
  }

  @media (max-width: 568px) {
    padding-bottom: 24px;
  }
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-inline: auto;
  max-width: 1366px;
  width: 100%;

  @media (max-width: 568px) {
    gap: 60px;
  }
`

export const TopContent = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 911px) {
    flex-direction: column;
    padding: 68px 24px 62px;

    & > figure {
      order: -1;
    }
  }

  @media (max-width: 568px) {
    gap: 0;
    padding-block: 64px 0;
  }
`

export const TextContent = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  & > h1 {
    color: #FFF;
    font-size: 2rem;
    font-weight: 700;

    & > span {
      color: #FFF;
      font-weight: 400;
    }
  }

  & > a {
    background-color: #FFE900;
    color: #007D55;

    &.laranja {
      background-color: #EB5A00;
      color: #FFFFFF;
    }
  }

  @media (min-width: 912px) {
    max-width: 384px;
    padding-block: 16px;
  }

  @media (max-width: 911px) {
    align-items: center;

    & > h1 {
      text-align: center;
    }
  }

  @media (min-width: 569px) and (max-width: 911px) {
    align-items: center;
  }

  @media (max-width: 568px) {
    max-width: 460px;

    & > h1 {
      font-size: 1.25rem;
    }

    & > a {
      width: 100%;
    }
  }
`

export const TextBoxContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  left: 0;
  bottom: -32px;
  position: absolute;
  margin-inline: auto;
  right: 0;
  max-width: 384px;
  width: 100%;

  & > span {
    color: #FFF;
    font-size: 1rem;
    font-weight: 700;
    line-height: 120%;
    text-transform: uppercase;
  }

  @media (max-width: 568px) {
    padding-inline: 24px;
  }
`

export const TextBox = styled.div`
  align-items: center;
  background-color: #FFF;
  border: 1px solid #013C1A;
  border-radius: 98px;
  display: flex;
  justify-content: space-around;
  padding: 8px 0;
  width: 100%;

  & > span {
    color: #1D1D1D;
    font-size: 1rem;
    font-weight: 400;
    text-align: center;
    width: 100%;

    & > strong {
      color: #013C1A;
      font-size: 2rem;
    }
  }

  & > hr {
    border-left: 1px solid #013C1A;
    height: 56px;
  }

  @media (max-width: 568px) {
    & > span {
      & > strong {
        font-size: 1.5rem;
      }
    }
  }
`

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  z-index: 1;

  & > div {
    aspect-ratio: 1;
    align-items: center;
    background-color: #084F43;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 176px;
    padding: 16px 24px;

    & > p {
      color: #FFF;
      font-size: 14px;
      font-weight: 400;
      line-height: 140%;
      text-align: center;

      & > span {
        align-items: flex-start;
        color: #A6FF00;
        display: inline-flex;
        font-weight: 500;
        font-size: 80px;
        line-height: 100%;
        vertical-align: top;

        & > small {
          font-size: 1.5rem;
          line-height: 1;
          vertical-align: top;
          position: relative;
          top: 0.4em;
        }
      }

      & > strong {
        font-size: 0.75rem;
        line-height: 140%;
        text-transform: uppercase;
      }
    }
  }

  @media (max-width: 911px) {
    flex-direction: row;
    gap: 16px;

    &.desktop {
      display: none;
    }

    & > div {
      flex: 1;
    }
  }


  @media (min-width: 912px) {
    &.mobile {
      display: none;
    }
  }

  @media (max-width: 911px) {
    &.mobile {
      flex-direction: row;
      width: fit-content;
    }
  }

  @media (max-width: 568px) {
    & > div {
      & > p {
        & > span {
          font-size: 3rem;

          & > small {
            top: 0.2em;
          }
        }

        & > strong {
          font-size: 0.75rem;
        }
      }
    }
  }
`

export const Benefits = styled.div`
  width: 100%;

  & > .swiper {
    & > .container > .cards {
      gap: 8px;
    }
  }

  @media (max-width: 568px) {
    margin: 0;
  }
`
